import { useFormContext } from "react-hook-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form/form";
import { HelperButton } from "@/components/ui/helper-button/helper-button";
import { Input } from "@/components/ui/input/input";

import { FormValues } from "../new-employee-form";
import { UploadPhoto } from "../upload-photo/upload-photo";

interface NewEmployeeOverviewProps {
  isPending: boolean;
}

export const NewEmployeeOverview = ({
  isPending,
}: NewEmployeeOverviewProps) => {
  const form = useFormContext<FormValues>();

  return (
    <div className="flex flex-col gap-5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="flex items-center gap-1">
                Name
                <HelperButton>
                  <p>Name of the Employee</p>
                </HelperButton>
              </FormLabel>
              <FormControl>
                <Input type="text" {...field} disabled={isPending} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="role"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="flex items-center gap-1">
                Role
                <HelperButton>
                  <p>Role of the Employee</p>
                </HelperButton>
              </FormLabel>
              <FormControl>
                <Input type="text" {...field} disabled={isPending} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="flex items-center gap-1">
                Email
                <HelperButton>
                  <p>Email of the Employee</p>
                </HelperButton>
              </FormLabel>
              <FormControl>
                <Input type="email" {...field} disabled={isPending} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="flex items-center gap-1">
                Password
                <HelperButton>
                  <p>Password of the Employee</p>
                </HelperButton>
              </FormLabel>
              <FormControl>
                <Input type="password" {...field} disabled={isPending} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <div>
        <FormField
          control={form.control}
          name="photo"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Upload Photo</FormLabel>
              <FormControl>
                <UploadPhoto value={field.value} onChange={field.onChange} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
